
export class AppConfig{
    hideIntroPage: boolean;
    hideSummaryPage: boolean;
    thankYouPageReloadTimer: number;

    constructor(hideIntroPage: boolean, hideSummaryPage: boolean, thankYouPageReloadTimer: number) {
        this.hideIntroPage = hideIntroPage;
        this.hideSummaryPage = hideSummaryPage;
        this.thankYouPageReloadTimer = thankYouPageReloadTimer;
    }
}